import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9fe52d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about container" }
const _hoisted_2 = { class: "top-cont" }
const _hoisted_3 = { class: "left-side" }
const _hoisted_4 = {
  class: "abs-img",
  alt: "Person"
}
const _hoisted_5 = { class: "right-side" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "about-title" }
const _hoisted_8 = ["innerHTML"]

import aboutGEO from '@/jsons/aboutGEO.json'
import aboutENG from '@/jsons/aboutENG.json'
import projects from '@/jsons/comercialProjects.json'
import { store } from '@/store/store';
import ProjectSlider from './ProjectSlider.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const Store = store();

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
          [_directive_lazy, { src: require('@/assets/me.webp'), loading: require('@/assets/loading.gif') }]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? _unref(aboutGEO).title : _unref(aboutENG).title), 1),
        (_unref(Store).getCurrentLang == 'GE')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(aboutGEO).stats, (item, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                _createElementVNode("p", null, _toDisplayString(item.val), 1)
              ]))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(aboutENG).stats, (item, i) => {
              return (_openBlock(), _createElementBlock("span", { key: i }, [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                _createElementVNode("p", null, _toDisplayString(item.val), 1)
              ]))
            }), 128)),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? _unref(aboutGEO).aboutTitle : _unref(aboutENG).aboutTitle), 1),
        _createElementVNode("p", {
          class: "desc",
          innerHTML: _unref(Store).getCurrentLang == 'GE' ? _unref(aboutGEO).description : _unref(aboutENG).description
        }, null, 8, _hoisted_8)
      ])
    ]),
    _createVNode(ProjectSlider, {
      title: _unref(Store).getCurrentLang == 'GE' ? 'კომერციული პროექტები' : 'Comercial projects',
      data: _unref(projects)
    }, null, 8, ["title", "data"])
  ]))
}
}

})